import { parseApiDate } from '@propertypal/shared/src/services/dayjs';
import React from 'react';
import { CalendarDay, CalendarMonth, Icon } from './CalenderIcon.style';

export interface CalendarIconProps {
  date: string;
  mode: 'black' | 'white';
}

const CalendarIcon: React.FC<CalendarIconProps> = ({ date, mode }) => {
  return (
    <>
      <Icon mode={mode} />
      <CalendarMonth mode={mode}>{parseApiDate(date).format('MMM')}</CalendarMonth>
      <CalendarDay mode={mode}>{parseApiDate(date).format('DD')}</CalendarDay>
    </>
  );
};

export default CalendarIcon;
